import { render, staticRenderFns } from "./QuickshipList.vue?vue&type=template&id=cc30e1fa&scoped=true&"
import script from "./QuickshipList.vue?vue&type=script&lang=ts&"
export * from "./QuickshipList.vue?vue&type=script&lang=ts&"
import style0 from "./QuickshipList.vue?vue&type=style&index=0&id=cc30e1fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc30e1fa",
  null
  
)

export default component.exports